import { breakpoints } from '../variables';
import TableScroll from './tableScroll';

export default class AddTable {
	constructor(el) {
		this.container = el;
		this.restUrl = '';
		this.nonce = '';
		this.tableId = typeof this.container.dataset.tableId !== 'undefined' ? this.container.dataset.tableId : 0;
		this.emptyRows = this.container.dataset.emptyRows;
		this.deviceType = '';
		this.load();
	}

	load() {
		try {
			if (this.tableId === 0) {
				throw new Error('Table Id not found');
			}

			this.fetchContent();
			return true;
		} catch (error) {
			console.warn(error);
			return false;
		}
	}

	async fetchContent() {
		const { tableId, emptyRows } = this;
		const valid = this.validate();

		await this.fetchCount((count) => {
			if (valid) {
				this.endpoint = `${this.restUrl}em/v1/em-tables/markup`;

				// Set Device Type.
				this.setDeviceType(count);

				try {
					if (typeof tableId === 'undefined') {
						throw new Error('Table Id Not found.');
					}
					if (this.container.querySelectorAll(`[data-table-type="${this.deviceType}"]`).length === 0) {
						fetch(this.endpoint, {
							method: 'POST',
							body: JSON.stringify({
								device_type: this.deviceType,
								post_id: tableId,
								empty_rows: emptyRows,
							}),
							headers: {
								'Content-Type': 'application/json',
								'X-WP-Nonce': this.nonce,
							},
						})
							.then((response) => response.json())
							.then((response) => {
								this.container.innerHTML = atob(response.markup);

								/**
								 * Load Table Scrolling Logic.
								 */
								const tables = [...this.container.querySelectorAll('[data-table-wrapper]')];
								try {
									if (!tables.length) {
										throw new Error('Table not loaded correctly. Class AddTable.js');
									}
									tables.map((table) => new TableScroll(table));
								} catch (error) {
									console.error(error);
								}
							})
							.catch((error) => {
								console.error('Error:', error);
							});
					}

					return true;
				} catch (error) {
					console.error('Error', error);
					return false;
				}
			} else {
				console.error('EmValidate access attempt invalid.');
				return false;
			}
		});
	}

	async fetchCount(callback) {
		const { tableId } = this;
		const valid = this.validate();
		if (valid) {
			this.endpoint = `${this.restUrl}em/v1/em-tables/column-count`;
			try {
				if (typeof tableId === 'undefined') {
					throw new Error('Table Id Not found.');
				}
				// Async Call.
				const response = await fetch(this.endpoint, {
					method: 'POST',
					body: JSON.stringify({
						post_id: tableId,
					}),
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce': this.nonce,
					},
				});
				const json = await response.json();
				if (json.response.table_column_count === null) {
					throw new Error(`Column count for table ${this.tableId} not found.`);
				}

				// Return Count in a callback function.
				callback(json.response.table_column_count);

				return true;
			} catch (error) {
				console.error('Error', error);
				return false;
			}
		} else {
			console.error('EmValidate access attempt invalid.');
			return false;
		}
	}

	/**
	 *	Sets Device Type based on breakpoints overridden by column counter.
	 *
	 * @param {in} count
	 */
	setDeviceType(count) {
		const { container } = this;
		const type = breakpoints.md.above() ? 'desktop' : 'mobile';
		this.deviceType = count > 7 ? 'mobile' : type;

		this.deviceType = 'desktop';
		container.setAttribute('data-device', this.deviceType);
	}

	validate() {
		const { EmValidate } = window;
		if (!EmValidate) {
			console.error('Error: ', 'EmValidate localize script not found.');
			return false;
		}
		if (!EmValidate.restUrl) {
			console.error('Error: ', 'EmValidate.resturl not found.');
			return false;
		}

		this.restUrl = EmValidate.restUrl;
		this.nonce = EmValidate.nonce;

		return true;
	}
}
